import "./popup.scss";
import * as React from "react";
import { type PopupId } from "./PopupManager";

interface Props {
    children: React.ReactNode;
    onHide?: () => void;
    timeout: number;
    remove: boolean;
    classes?: Array<string>;
    id: PopupId;
}

interface State {
    timer: false | ReturnType<typeof setTimeout>;
    classes: Array<string>;
}

export default class Popup extends React.Component<Props, State> {
    public state: State = {
        timer  : false,
        classes: [ "entering" ],
    };

    public componentDidMount(): void {
        this.setState({
            timer: setTimeout(() => {
                this.setState({
                    classes: [],
                });
            }, 500),
        });
    }

    public componentWillUnmount(): void {
        if(this.state.timer !== false) {
            clearTimeout(this.state.timer);
        }
    }

    public componentDidUpdate(prevProps: Readonly<Props>): void {
        if(!prevProps.remove && this.props.remove) {
            this.setState({
                classes: [ "exiting" ],
                timer  : setTimeout(() => {
                    this.props.onHide?.();
                }, 500),
            });
        }
    }

    public render(): React.ReactNode {
        let propClasses = this.props.classes;

        if(!propClasses) {
            propClasses = [];
        }

        const classes = [
            "popup",
            ...propClasses,
            ...this.state.classes,
        ];

        let style = {};

        if(this.props.timeout) {
            classes.push("has-timeout");
            style = {
                animationDuration: `${this.props.timeout}ms`,
            };
        } else {
            classes.push("no-timeout");
        }

        return (
            <div
                className={classes.join(" ")}
                data-testid="popup-message"
            >
                <div className="popup-content">
                    {this.props.children}
                    <div
                        className="timeout-display"
                        style={style}
                    >
                        {(!this.props.timeout && (
                            <svg xmlns="http://www.w3.org/2000/svg" width="200%" height="100%">
                                <defs>
                                    <pattern id={`pattern-${this.props.id}`} patternUnits="userSpaceOnUse" width="2%" height="45" patternTransform="rotate(45)">
                                        <line x1="0" y="0" x2="0" y2="45" stroke="currentColor" strokeWidth="2%" />
                                    </pattern>
                                </defs>
                                <rect width="100%" height="100%" fill={`url(#pattern-${this.props.id})`} opacity="1" />
                            </svg>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}
